import React from 'react';
import { Stack, Flex } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import EntrantsList from '~/domains/contest/domains/common/components/Entrants/EntrantsList';
import { ButtonLink } from '~/domains/design-system/Button';
import { useContestEntrantsInfinite } from '~/domains/contest/hooks/useContestEntrantsInfinite';
import { Routes } from '~/domains/common/constants/routes';

type EntrantsProps = {
  contestId: string;
  source?: 'contest_detail_entrants' | 'upcoming_entrants';
};

function Entrants({ contestId, source = 'contest_detail_entrants' }: EntrantsProps) {
  const { t } = useTranslation('contest');
  const { entrants, isLoading, isError, hasNextPage, refetch } = useContestEntrantsInfinite({
    contestId,
    source,
    pageSize: 10,
  });

  const hasMoreEntrants = entrants.length > 0 && (entrants.length >= 10 || hasNextPage);

  return (
    <Stack w="100%" spacing={0}>
      <EntrantsList
        isError={isError}
        isLoading={isLoading}
        items={entrants}
        source={source}
        contestId={contestId}
        fetchNextPage={() => {}}
        hasNextPage={false}
        isFetchingNextPage={false}
        refetch={refetch}
      />

      {hasMoreEntrants && (
        <Flex justify="center" mt="sm">
          <ButtonLink
            variant="text"
            size="small"
            onClick={() => window.scrollTo({ top: 0 })}
            href={Routes.gamecenterEntrants(contestId)}
          >
            {t('detail.tabs.entrants')}
          </ButtonLink>
        </Flex>
      )}
    </Stack>
  );
}

export default Entrants;
